import React from 'react'

import './Footer.css'
const Footer = () => {
  return (
    <div className='footer-container'></div>
  )
}

export default Footer